import { ChevronLeft } from "lucide-react";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { useTranslation } from "react-i18next";

type TFormView = "add" | "edit";

const FORM_TITLE_KEYS = {
  add: "dimensions.newTitle",
  edit: "dimensions.editTitle"
} as const satisfies Record<TFormView, string>;

type TProps = {
  view: TFormView;
  disabled: boolean;
  onBack: () => void;
};

export function DimensionsFormTitle(props: TProps) {
  const { view, disabled, onBack } = props;
  const { t } = useTranslation("projects");

  return (
    <div className="flex items-center gap-2.5">
      <button
        type="button"
        className="flex items-center justify-center text-zinc-700 hover:text-zinc-900 disabled:opacity-50"
        onClick={onBack}
        disabled={disabled}
      >
        <ChevronLeft className="h-5 w-5" strokeWidth={1.5} />
      </button>
      <FigmaTypography component="span" variant="heading-3" color="zinc900">
        {t(FORM_TITLE_KEYS[view])}
      </FigmaTypography>
    </div>
  );
}
